import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=35e6f965&"
import script from "./VerticalMenu.js?vue&type=script&lang=js&"
export * from "./VerticalMenu.js?vue&type=script&lang=js&"
import style0 from "./VerticalMenu.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports